import { createReducer } from '@reduxjs/toolkit';
import { getNews } from '../actions/newsPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getNews.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
